import styled from 'styled-components';

export const CheckMark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 1.5rem;
  width: 1.5rem;
  border: 1px solid var(--color-mono-0);
  border-radius: 50%;
  background-color: #ffffff;
  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`;

export const Container = styled.label`
  display: flex;
  position: relative;
  padding-left: 32px;
  cursor: pointer;
  border-radius: 1.5rem;
  font-size: var(--fontSizes-normal);
  line-height: var(--lineHeights-normal);
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  // When radiobutton is hovered and is unchecked
  &:hover input:not(:checked) ~ ${CheckMark} {
    &:after {
      top: 7px;
      left: 7px;
      width: 8px;
      height: 8px;
      display: block;
    }
  }

  input:checked ~ ${CheckMark} {
    &:after {
      display: block;
    }
  }

  // When radiobutton is checked
  ${CheckMark}:after {
    top: 3px;
    left: 3px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: black;
  }
  &:focus-within {
    outline: var(--focus-style);
    outline-offset: 2px;
  }
`;
